<template>
    <div>
        <!-- 西城底部 -->
        <HomeFooter
            v-if="fromTemplateId == '2'"
            :brand="brand"
            :showFooterBg="showFooterBg"
            :linkList="linkList"
        />
        <!-- 通用底部 -->
        <CommonHomeFooter v-else />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import CommonHomeFooter from './part/footer/common-index.vue';
import { HomeFooter } from '@yanxiu/footer';
import { useStore } from 'vuex';

const store = useStore();

const showFooterBg = computed(() => {
    // 只有西城品牌有
    return brand.value?.publishBrand?.brand == 'xcjyyxw';
});

const fromTemplateId = computed(() => {
    // 站点模板
    return store.state.user?.fromTemplateId || '';
});

// 全部备案信息
const brand = computed(() => {
    return store.state.brand || {};
});

const linkList = computed(() => {
    const brandKey = brand.value?.publishBrand?.brand;
    if (brandKey === 'shanghaijyzx') {
        return [
            {
                name: '中华人民共和国教育部',
                url: 'http://www.moe.gov.cn/',
            },
            {
                name: '上海智慧教育平台 · 微校',
                url: 'https://www.sh.smartedu.cn/ ',
            },
        ];
    }
    return undefined;
});
</script>
